var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewui2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "#ffffff",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: 15,
    width: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.5,13.5c0,.276-.224.5-.5.5s-.5-.224-.5-.5v-3h-3c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h3v-3c0-.276.224-.5.5-.5s.5.224.5.5v3h3c.276,0,.5.224.5.5s-.224.5-.5.5h-3v3Zm9.5-9v9.373c0,.921-.374,1.823-1.025,2.475l-2.627,2.627c-.651.651-1.554,1.025-2.475,1.025h-9.373c-2.481,0-4.5-2.019-4.5-4.5V4.5C4,2.019,6.019,0,8.5,0h11c2.481,0,4.5,2.019,4.5,4.5Zm-15.5,14.5h8.5v-3.5c0-1.379,1.121-2.5,2.5-2.5h3.5V4.5c0-1.93-1.57-3.5-3.5-3.5h-11c-1.93,0-3.5,1.57-3.5,3.5v11c0,1.93,1.57,3.5,3.5,3.5Zm14.487-5h-3.487c-.827,0-1.5.673-1.5,1.5v3.487c.613-.032,1.205-.284,1.641-.72l2.627-2.627c.436-.436.688-1.028.72-1.641Zm-5.487,9H4.5c-1.93,0-3.5-1.57-3.5-3.5V6.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5v13c0,2.481,2.019,4.5,4.5,4.5h13c.276,0,.5-.224.5-.5s-.224-.5-.5-.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewui2);
export default __webpack_public_path__ + "static/media/newui2.0750ef29b236a3f91369995b5866b744.svg";
export { ForwardRef as ReactComponent };